// extracted by mini-css-extract-plugin
module.exports = {"Content":"session-expired-dialog_Content__9UHMR","CloseButton":"session-expired-dialog_CloseButton__5Jl2i"};